// User-facing credit balance API. Signed-in users only — reads their
// own bonus credit balance + last 20 grant/deduct entries.

import { getToken } from './auth';

const API_BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');

export async function getMyCredits() {
  const token = getToken();
  if (!token) return null;
  const res = await fetch(`${API_BASE}/api/users/me/credits`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return null;
  try {
    const data = await res.json();
    return data?.credits || null;
  } catch { return null; }
}
